// extracted by mini-css-extract-plugin
export var labelWrapper = "_h7-0";